<template>
  <div>
    <topsearch title="Utm Raporu" />
    <div class="flex">
      <div class="w-72 border-r h-full">
        <SidebarVue />
      </div>
      <div class="w-full">
        <div class="overflow-scroll min-h-screen md:p-4">
          <table
            class="
              uk-table
              border
              uk-table-hover
              heightoverflow
              uk-table-middle uk-table-divider
            "
          >
            <tr>
              <th class="border-l">
                <select v-model="utmKey" @change="getData()" class="uk-select">
                  <option value="utm_source">Utm source</option>
                  <option value="utm_campaign">Utm campaign</option>
                  <option value="country_id">Country</option>
                  <option value="agent_id">Agent</option>
                </select>
              </th>
              <th class="border-l" v-for="td in statuses">
                {{ td.name }}
              </th>
            </tr>
            <tr v-for="(tr, utm) in data">
              <td class="border-l">{{ nameConvert(utm) }}</td>
              <th class="border-l" v-for="td in statuses">
                <a
                  :href="
                    '/list/leads?' +
                      utmKey +
                      '=' +
                      utm +
                      '&status_id=' +
                      td.id +
                      ''
                  "
                >
                  {{ tr[td.id] }}
                </a>
              </th>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarVue from "../components/Ui/Admin/Sidebar.vue";
import languageKey from "../components/Ui/Form/languageKey.vue";
import http from "../services/http";
export default {
  components: { languageKey, SidebarVue },
  name: "reportUtm",
  data() {
    return { data: [], statuses: [], utmKey: "utm_source" };
  },
  created() {
    this.getData();
  },
  methods: {
    nameConvert(name) {
      if (this.utmKey == "agent_id") {
        return this.$root.getVal(15, name);
      }
      if (this.utmKey == "country_id") {
        return this.$root.getVal(37, name);
      }
      return name;
      /*
      $root.getVal(15, result.agent_id)
      */
    },
    getData() {
      http.getUtmReport({ utmKey: this.utmKey }).then(response => {
        this.data = response.data.report;
        this.statuses = response.data.status;
      });
    }
  }
};
</script>

<style></style>
